import { z } from "zod";

export const FtpSchema = z.object({
    ID: z.string(),
    Name: z.string().min(1, "Password must be a minimum of 1 characters"),
    Server: z.string().min(1, "Password must be a minimum of 1 characters"),
    Username: z.string().min(1, "Password must be a minimum of 1 characters"),
    Password: z.string(),
    CB_approved: z.number(),
});

export const FtpFormSchema = z.object({
    Name: z.string().min(1, "Password must be a minimum of 1 characters"),
    Server: z.string().min(1, "Password must be a minimum of 1 characters"),
    Username: z.string().min(1, "Password must be a minimum of 1 characters"),
    Password: z.string(),
});
